<template>
  <div class="first">
    <title-bar-back :title="queryBrandById.name" @back="back">
      <div class="mr_right"></div>
      <!-- <div>
        <img
          src="@/assets/common/icon_search_black@2x.png"
          alt=""
          class="title_img"
          @click="goSearch"
        />
        <img
          src="@/assets/common/icon_cart@2x.png"
          alt=""
          class="title_img mr"
        />
      </div> -->
    </title-bar-back>
    <!-- 分类切换 -->
    <two-switch v-if="false" @TwoSwitch="TwoSwitch" />
    <!-- 分类图 -->
    <div class="cate_all">
      <img :src="queryBrandById.adImg" alt="" />
    </div>
    <!-- 简介 -->
    <div v-if="queryBrandById.resume" class="bg_f">
      <div class="cate_title">
        {{ queryBrandById.name }}
      </div>
      <div class="cate_title_det">
        {{ queryBrandById.resume }}
      </div>
    </div>
    <!-- 新品切换 -->
    <slot-switch @switchCate="switchCate" />
    <!-- 标签 -->
    <tag-list v-if="$appSource != 3" @switchTag="switchTag" />
    <!-- 底部商品 -->
    <recommend
      :productCon="searchProductList"
      :loadings="loadings"
      @onRefresh="onRefresh"
      @onLoad="onLoad"
      @showPoster="showPosters"
    />
    <!-- 海报 -->
    <poster
      v-if="showPoster"
      :show="showPoster"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask v-if="showShareMask" @hideMask="hideMask" />
  </div>
</template>
<script>
import NativeShare from "nativeshare";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import TwoSwitch from "../firstproduct/components/TwoSwitch";
import SlotSwitch from "../firstproduct/components/SlotSwitch";
import TagList from "../firstproduct/components/TagList";
const Recommend = () =>
  import("@/components/Recommend").then(m => m.default || m);
const ShareMask = () =>
  import("../../mine/cardvoucher/components/ShareMask").then(
    m => m.default || m
  );
const Poster = () =>
  import("../../product/detail/components/Poster").then(m => m.default || m);
export default {
  name: "Brand",
  components: {
    TitleBarBack,
    TwoSwitch,
    SlotSwitch,
    Recommend,
    TagList,
    Poster,
    ShareMask
  },
  data() {
    return {
      tagId: 0,
      brandId: this.$route.query.id,
      loadings: false,
      cateId: 0,
      cateSwitchIndex: 0,
      sort: "",
      direction: "",
      showPoster: false,
      showShareMask: false,
      posterItem: {}
    };
  },
  computed: {
    queryBrandById() {
      return this.$store.getters.queryBrandById;
    },
    searchProductList() {
      return this.$store.getters.searchProductList;
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    }
  },
  watch: {
    searchProductList: {
      handler(old, newValue) {
        console.log(old, newValue);
      },
      deep: true
    },
    queryBrandById: {
      handler(old, newValue) {
        console.log(old, newValue);
      },
      deep: true
    }
  },
  created() {
    this.getData(this.brandId);
    this.getUserData();
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 品牌馆数据queryBrandById
    // 获取分类数据
    getData(id) {
      const params = {
        id
      };
      this.$store
        .dispatch("product/queryBrandById", { params })
        .then(() => {
          // 获取商品数据
          const params = {
            pageNo: 1,
            pageSize: 20,
            brandId: this.brandId
          };
          this.getCateData(params);
        })
        .catch(() => {});
    },
    // 海报获取用户数据
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    // 刷新
    onRefresh() {
      this.getData(this.brandId);
      this.getUserData();
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loadings = false;
      if (
        this.searchProductList.hasNextPage &&
        this.searchProductList.pageNo <= this.searchProductList.pageCount
      ) {
        this.loadings = true;
        const pageIndex = this.searchProductList.pageNo + 1;
        const params = {
          pageNo: 1,
          pageSize: pageIndex,
          brandId: this.brandId
        };
        if (this.tagId) {
          params.tradeType = this.tagId;
        }
        if (this.sort) {
          params.sort = this.sort;
        }
        if (this.direction) {
          params.direction = this.direction;
        }
        this.getCateData(params);
        // console.log("上拉完毕");
      }
    },
    //分类数据请求
    getCateData(params) {
      this.$store
        .dispatch("product/findClientRetailSpuByParam", {
          params
        })
        .then(() => {})
        .catch(() => {});
    },
    // 三级分类切换
    TwoSwitch(index, name, id) {
      // console.log(index, name, id);
      this.cateSwitchIndex = index;
      // this.cateId = id;
      this.brandId = id;
      const params = {
        pageNo: 1,
        pageSize: 20,
        brandId: id
      };
      this.getCateData(params);
    },
    // 新品价格切换
    switchCate(index, newSlot, priceSlot) {
      const params = {
        pageNo: 1,
        pageSize: 20,
        brandId: this.brandId
      };
      if (newSlot) {
        this.sort = "gmtCreate";
        this.direction = newSlot;
        params.sort = "gmtCreate";
        params.direction = newSlot;
      }
      if (priceSlot) {
        this.sort = "gmtCreate";
        this.direction = priceSlot;
        params.sort = "gmtCreate";
        params.direction = priceSlot;
      }
      this.getCateData(params);
    },
    // 切换标签
    switchTag(index, id) {
      this.tagId = id;
      // console.log(id, "标签");
      const params = {
        pageNo: 1,
        pageSize: 20,
        brandId: this.brandId //分类id
      };
      if (id !== -1) {
        params.tradeType = id; //贸易类型  0-直邮  1-保税区  2- 一般贸易
      }
      this.getCateData(params);
    },
    // 搜索跳转
    goSearch() {
      this.$router.push("/search");
    },
    showPosters(productDetail) {
      this.posterItem = productDetail;
      this.showPoster = true;
    },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // console.log(typeof NativeShare);
      // console.log(NativeShare, 88888);
      if (typeof NativeShare !== "undefined") {
        // console.log(111);
        if (this.isWechatBrowser()) {
          // console.log(222);
          this.showPoster = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
      } else {
        this.showPoster = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.first {
  // background: #fff;
  .title_img {
    width: 24px;
  }
  .mr {
    margin-left: 12px;
  }
  .cate_all {
    img {
      width: 100%;
      max-height: 120px;
      display: block;
    }
  }
  .bg_f {
    margin-bottom: 12px;
  }
  .cate_title {
    padding-top: 12px;
    font-size: 16px;
    font-weight: 400;
    color: #000;
    line-height: 22px;
  }
  .cate_title_det {
    padding: 8px 18px 0;
    font-size: 12px;
    font-weight: 400;
    color: #000;
    line-height: 17px;
    // text-align: left;
  }
}
</style>
